"use strict";

var __assign = undefined && undefined.__assign || Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) {
            if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
    }
    return t;
};
var __importDefault = undefined && undefined.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var HeDatatable_vue_1 = __importDefault(require("./HeDatatable.vue"));
exports.HeDatatable = HeDatatable_vue_1.default;
var vue_1 = __importDefault(require("vue"));
vue_1.default.component("he-datatable", HeDatatable_vue_1.default);
$(function () {
    var $datatables = $(".vue-datatable");
    if ($datatables.length > 0) {
        $datatables.each(function (i, dt) {
            var $dt = $(dt),
                $templates = $dt.find("template");
            var heDt = new HeDatatable_vue_1.default({
                el: dt,
                propsData: __assign({}, $dt.data())
            });
            heDt.$el["component"] = heDt;
        });
    }
});


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/SharedComponent/HeDatatable/index.ts
// module id = 631
// module chunks = 0